import { useCallback, useContext, useState } from 'react';

import { ModalContext, ModalContextType } from '@contexts/modalContext';

// Custom hook to use modal context
export const useModal = (): ModalContextType => {
    const context = useContext(ModalContext);
    if (!context) {
        throw new Error('useModal must be used within a ModalProvider');
    }
    return context;
};

// Custom hook to manage modal state
export const useModalManager = () => {
    const [openModals, setOpenModals] = useState<{ id: string; props: any }[]>([]);

    const openModal = useCallback((modalId: string, props?: any) => {
        setOpenModals(prev => [...prev, { id: modalId, props }]);
    }, []);

    const closeModal = useCallback((modalId: string) => {
        setOpenModals(prev => prev.filter(modal => modal.id !== modalId));
    }, []);

    const closeAllModals = useCallback(() => {
        setOpenModals([]);
    }, []);

    return { openModals, openModal, closeModal, closeAllModals };
};
